"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PEPPOL_REMOTA_GENERATED = exports.PEPPOL_JOB_ID = exports.EMAIL_REMOTA_GENERATED = exports.EMAIL_JOB_ID = exports.OVERSEAS_LANGUAGE_JOBS = exports.REQUIRED_LANGUAGE_DETECTION_JOBS = void 0;
exports.REQUIRED_LANGUAGE_DETECTION_JOBS = ["invoice_international"];
exports.OVERSEAS_LANGUAGE_JOBS = ["invoice_english"];
exports.EMAIL_JOB_ID = "00000000-0000-0000-0000-000000000000";
exports.EMAIL_REMOTA_GENERATED = "EMAIL_REMOTA_GENERATED";
exports.PEPPOL_JOB_ID = "00000000-0000-0000-0000-000000000000";
exports.PEPPOL_REMOTA_GENERATED = "PEPPOL_REMOTA_GENERATED";
